import { FormattedMessage } from "react-intl";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import PaymentData from "@brand/PaymentData/PaymentData";
import PropTypes from "prop-types";
import { USABLE_CREDITS_STATUS } from "app/constants";
import { isExternalPaymentError, isPaymentError } from "app/utils/paymentUtils";
import { paymentTypesValues } from "app/utils/propTypes";
import PaymentSecurityNote from "app/pages/Booking/Payment/PaymentSecurityNote";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useEffect, useRef } from "react";
import useOnScreen from "app/pages/.shared/useOnScreen";
import { useFormikContext } from "formik";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

function PaymentInfoSection({
	brandDisplayName,
	usableCouponsStatus,
	payment = {},
	shop,
	selectedPaymentType,
	error,
	paymentErrorMessageRef,
	paymentMethodsErrorMessageRef,
	handleInputBlur = () => {},
	onAdyenComponentMounted = () => {},
	setPaymentError = () => {},
}) {
	const { values } = useFormikContext();

	const isCouponsLoading =
		usableCouponsStatus === USABLE_CREDITS_STATUS.LOADING_CREDIT_NOTES ||
		usableCouponsStatus === USABLE_CREDITS_STATUS.LOADING_COUPONS;

	const { track } = useAnalytics();
	const ref = useRef();
	const isElementOnScreen = useOnScreen({ ref, triggerOnce: false });

	useEffect(() => {
		if (isElementOnScreen && !isCouponsLoading) {
			track("payment_view_Payment");
		}
	}, [isElementOnScreen, isCouponsLoading]);

	const bookStatus = payment.bookStatus;

	return (
		<>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL3}
				variantMD={TYPOGRAPHY_VARIANTS.XL4}
				isBold
				className="payment__title"
				component="h2"
				innerRef={ref}
			>
				<FormattedMessage id="payment.payment.title" />
			</Typography>
			<PaymentSecurityNote brandDisplayName={brandDisplayName} />
			{isCouponsLoading ? (
				<div className="payment__content">
					<LoaderBar />
				</div>
			) : (
				<div className="payment__content">
					<PaymentData
						error={error}
						fields={values}
						isExternalPaymentError={isExternalPaymentError(bookStatus)}
						isPaymentError={isPaymentError(bookStatus)}
						onAdyenComponentMounted={onAdyenComponentMounted}
						onCreditCardInputsBlur={handleInputBlur}
						selectedPaymentType={selectedPaymentType}
						shop={shop}
						paymentModesRef={paymentErrorMessageRef}
						paymentMethodsRef={paymentMethodsErrorMessageRef}
						setPaymentError={setPaymentError}
					/>
				</div>
			)}
		</>
	);
}

PaymentInfoSection.propTypes = {
	brandDisplayName: PropTypes.string,
	usableCouponsStatus: PropTypes.string,
	payment: PropTypes.object,
	shop: PropTypes.string,
	selectedPaymentType: paymentTypesValues,
	error: PropTypes.object,
	paymentErrorMessageRef: PropTypes.string,
	paymentMethodsErrorMessageRef: PropTypes.string,
	handleInputBlur: PropTypes.func,
	onAdyenComponentMounted: PropTypes.func,
	setPaymentError: PropTypes.func,
};
export default PaymentInfoSection;
